import { render } from "./RelatorioConcentracaoContratosAtivosView.vue?vue&type=template&id=b1e7cc20"
import script from "./RelatorioConcentracaoContratosAtivosView.vue?vue&type=script&lang=js"
export * from "./RelatorioConcentracaoContratosAtivosView.vue?vue&type=script&lang=js"

import exportComponent from "C:\\GarantePay\\Desenvolvimento2026\\CodigoVue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__